export const gallery = {
  title: "La vie à Gándara",
  subtitle: "Un espace pour grandir, explorer et découvrir"
};
